Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.EventPhase = module.exports.default = {
	AT_TARGET: 2,
	BUBBLING_PHASE: 3,
	CAPTURING_PHASE: 1
};